import * as React from 'react'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'

import i18n from 'modules/core/lib/i18n'

import ArchiveCategoryModal from 'modules/time_categories_settings/components/NewWorkTimeCategories/ArchiveModal'
import CategoryModal from 'modules/time_categories_settings/components/NewWorkTimeCategories/CategoryModal'
import { CustomTimeRangeCategory } from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'
import type { CustomTimeRangeCategoryFormType } from 'modules/time_categories_settings/lib/forms/CreateCustomTimeRangeCategoryForm'
import EditCustomTimeRangeCategoryForm from 'modules/time_categories_settings/lib/forms/EditCustomTimeRangeCategoryForm'

import CategoryMenu from './Menu'

interface Props {
  category: CustomTimeRangeCategory
}

const CategoryCard = ({ category }: Props) => {
  const [modalOpen, setModalOpen] = React.useState(false)
  const [archiveModalOpen, setArchiveModalOpen] = React.useState(false)

  const tagConfig = {
    ['overtime']: {
      color: Tag.Types.tangerine,
      text: i18n.t('work_time_categories.time_type.overtime'),
    },
    ['regular']: {
      color: Tag.Types.grey,
      text: i18n.t('work_time_categories.time_type.regular'),
    },
    ['any_time']: null,
  }

  const timeType = tagConfig[category.timeType]
  // eslint-disable-next-line no-type-assertion/no-type-assertion
  const form = EditCustomTimeRangeCategoryForm({
    category,
    setModalOpen,
  }) as FormikProps<CustomTimeRangeCategoryFormType>

  return (
    <Box
      width="full"
      component="ul"
      borderRadius={{ all: 'abs008' }}
      border={{
        all: {
          width: 's1',
          color: 'grey400',
          style: 'solid',
        },
      }}
      gapDivider
    >
      <Box
        component="li"
        flexDirection="row"
        justifyContent="spaceBetween"
        paddingY="s16"
        paddingX="s24"
        alignItems="center"
      >
        <Text size="300" weight="medium">
          {category.name}
        </Text>
        <Box flexDirection="row" alignItems="center" gap="s16">
          {timeType && <Tag type={timeType.color}>{timeType.text}</Tag>}
          <CategoryMenu setModalOpen={setModalOpen} setArchiveModalOpen={setArchiveModalOpen} />
        </Box>
        {modalOpen && <CategoryModal setModalOpen={setModalOpen} form={form} />}
        {archiveModalOpen && (
          <ArchiveCategoryModal
            categoryId={category.id}
            name={category.name}
            setArchiveModalOpen={setArchiveModalOpen}
          />
        )}
      </Box>
    </Box>
  )
}

export default CategoryCard
